export class SmartTableModel {
    personOnBoardId: number;
    sequenceNumber: number;
    givenName: string;
    familyName: string;
    gender: string;
    nationality: string;
    dateOfBirth: any;
    portOfEmbarkation: string;
    portOfDisembarkation: string;
    rankName: string;
    nationalityTwoCharCode: string;
    countryOfBirthTwoCharCode: string;
    isMaster: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main-content/content-container/port-call/registration/forms/passenger-list/smartTableModel.ts